<div class="alert" [class]="'alert alert--' + tone" [class.alert--compact]="compact" [attr.role]="role">
    <mat-icon class="alert__icon" aria-hidden="true">{{ resolvedIcon }}</mat-icon>
    <div class="alert__content">
        @if (title) {
            <strong class="alert__title">{{ title }}</strong>
        }
        <ng-content></ng-content>
    </div>
    @if (actionUrl && actionLabel) {
        <a class="alert__action" [href]="actionUrl" [attr.target]="actionNewTab ? '_blank' : null" [attr.rel]="actionNewTab ? 'noopener noreferrer' : null">{{ actionLabel }}<mat-icon aria-hidden="true">open_in_new</mat-icon></a>
    }
</div>
